module.exports = __webpack_public_path__ + "media/Resources/Book-8c6aeb30.svg";